
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/CaPrivacyRights",
      function () {
        return require("private-next-pages/CaPrivacyRights.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/CaPrivacyRights"])
      });
    }
  